"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
const zod_1 = require("zod");
exports.Result = zod_1.z.union([
    zod_1.z.object({
        ok: zod_1.z.literal(true),
        value: zod_1.z.any(),
    }),
    zod_1.z.object({
        ok: zod_1.z.literal(false),
        error: zod_1.z
            .object({
            message: zod_1.z.string(),
        })
            .optional(),
    }),
]);
